export default __webpack_public_path__ + "static/media/DB_9.c1630015.png";